import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
import ButtonView from '@src/plugins/ckeditor5-ui/src/button/buttonview';
import formulaIcon from '../theme/icons/formula.svg';
import KityFormularView from './kityFormulaView';
export default class KityFormulaUI extends Plugin {
	static get pluginName() {
		return 'KityFormulaUI';
	}

	init() {
		const editor = this.editor;
		const componentFactory = editor.ui.componentFactory;
		componentFactory.add( 'kityformula', locale => {
			const command = editor.commands.get( 'kityformula' );
			const button = new ButtonView( locale );
			button.set( {
				label: '插入公式',
				icon: formulaIcon,
				tooltip: true
			} );
			button.bind( 'isEnabled' ).to( command );

			button.on( 'execute', () => {
				editor.editing.view.focus();
				this._showFormulaView();
			} );
			return button;
		} );
	}

	_showFormulaView() {
		const container = this.editor.ui.view.element || this.editor.ui.view.editable.element.parentElement;

		const locale = this.editor.locale;
		if ( !this.formulaView ) {
			this.formulaView = new KityFormularView( locale );
			this.formulaView.render();
			this.formulaView.on( 'close', () => {
				container.removeChild( this.formulaView.element );
				this.formulaView = null;
			} );
			this.formulaView.on( 'insertAsImage', () => {
				this.formulaView.element.querySelector( 'iframe' ).contentWindow.onok( data => {
					if ( notNull( data ) ) {
						this.editor.execute( 'kityFormulaInsertCommand', { type: 'image', img: data } );
						container.removeChild( this.formulaView.element );
						this.formulaView = null;
						this.editor.view.focus();
					}
				} );
			} );
			this.formulaView.on( 'insertInline', data => {
				this.formulaView.element.querySelector( 'iframe' ).contentWindow.onokinline( data => {
					if ( notNull( data.alt ) ) {
						this.editor.execute( 'kityFormulaInsertCommand', { type: 'inline', src: data.src, alt: data.alt } );
						container.removeChild( this.formulaView.element );
						this.formulaView = null;
						this.editor.view.focus();
					}
				} );
			} );
			setTimeout( () => {
				container.appendChild( this.formulaView.element );
			} );
		}
		//
		this.formulaView.visibleClass = 'ck-fdialog-visible';
	}

	destroy() {
		if ( this.formulaView ) {
			this.formulaView.destroy();
			this.formulaView = null;
		}
	}
}
function notNull( data ) {
	return data && data.indexOf( 'placeholder' ) < 0;
}
